import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconOpencode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"opencode"} maskId="square-outlined-radius-0-stroke-1-IconOpencode"><path opacity="0.4" d="M16 10.0002V18.0002H8V10.0002H16Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M20 22H4V2H20V22ZM16 6H8V18H16V6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconOpencode;
